var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023-2025 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect, useState } from "react";
import { useGetOne, useSidebarState } from "react-admin";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { IconButton } from "@sequentech/ui-essentials";
import { Box, Select } from "@mui/material";
import { AuthContext } from "../../../providers/AuthContextProvider";
import { useTenantStore } from "../../../providers/TenantContextProvider";
import { IPermissions } from "../../../types/keycloak";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { CreateTenant } from "@/resources/Tenant/CreateTenant";
var SelectTenants = function () {
    var _a = useTenantStore(), tenantId = _a[0], setTenantId = _a[1];
    var authContext = useContext(AuthContext);
    var i18n = useTranslation().i18n;
    var isOpenSidebar = useSidebarState()[0];
    var _b = useState(false), isNewTenantOpen = _b[0], setIsNewTenantOpen = _b[1];
    var showAddTenant = authContext.isAuthorized(true, null, IPermissions.TENANT_CREATE);
    var data = useGetOne("sequent_backend_tenant", {
        id: tenantId,
    }).data;
    useEffect(function () {
        if (!tenantId && authContext.tenantId) {
            setTenantId(authContext.tenantId);
        }
        if ((data === null || data === void 0 ? void 0 : data.length) === 1) {
            setTenantId(data[0].id);
        }
    }, [data, tenantId, authContext.tenantId, setTenantId]);
    return (_jsxs(Container, __assign({ className: "select-tenants", hasSingle: true }, { children: [_jsx(AccountCircleIcon, {}), isOpenSidebar && !!data && (_jsxs(_Fragment, { children: [_jsx(SingleDataContainer, __assign({ className: "tenant-name", style: {
                            textAlign: i18n.dir(i18n.language) === "rtl" ? "start" : "start",
                            marginLeft: 0,
                        } }, { children: data.slug })), showAddTenant ? (_jsx(StyledIcon, { icon: faPlusCircle, onClick: function () { return setIsNewTenantOpen(true); } })) : null] })), isNewTenantOpen && (_jsx(CreateTenant, { isDrawerOpen: isNewTenantOpen, setIsDrawerOpen: setIsNewTenantOpen }))] })));
};
export default SelectTenants;
var Container = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "hasSingle"; }, // Prevent `hasSingle` from being passed to the DOM
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding-left: 16px;\n    padding-right: 16px;\n    & > *:not(:last-child) {\n        margin-right: 12px;\n    }\n    padding-top: ", ";\n    padding-bottom: ", ";\n"], ["\n    display: flex;\n    align-items: center;\n    padding-left: 16px;\n    padding-right: 16px;\n    & > *:not(:last-child) {\n        margin-right: 12px;\n    }\n    padding-top: ", ";\n    padding-bottom: ", ";\n"])), function (_a) {
    var hasSingle = _a.hasSingle;
    return (hasSingle ? "0.375rem" : "0.25rem");
}, function (_a) {
    var hasSingle = _a.hasSingle;
    return (hasSingle ? "0.375rem" : "0.25rem");
});
var SingleDataContainer = styled("p")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-grow: 1;\n    margin-left: 0.625rem;\n"], ["\n    flex-grow: 1;\n    margin-left: 0.625rem;\n"])));
var StyledIcon = styled(IconButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    &:hover {\n        padding: unset !important;\n    }\n    font-size: 1rem;\n    line-height: 1.5rem;\n"], ["\n    &:hover {\n        padding: unset !important;\n    }\n    font-size: 1rem;\n    line-height: 1.5rem;\n"])));
var StyledSelect = styled(Select)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-grow: 1;\n    margin-left: 0;\n    margin-right: 0;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n"], ["\n    flex-grow: 1;\n    margin-left: 0;\n    margin-right: 0;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
